export default __webpack_public_path__ + "static/media/dustbin_icon_dark.b39ed195.svg";